import { render, staticRenderFns } from "./IlliquidDataDate.vue?vue&type=template&id=077c2dc4&scoped=true&"
import script from "./IlliquidDataDate.vue?vue&type=script&lang=js&"
export * from "./IlliquidDataDate.vue?vue&type=script&lang=js&"
import style0 from "./IlliquidDataDate.vue?vue&type=style&index=0&id=077c2dc4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "077c2dc4",
  null
  
)

export default component.exports